webpackJsonp([11],{

/***/ 174:
/***/ (function(module, exports) {

module.exports = {"jugar":"Play","instrucciones":"Instructions"}

/***/ })

});


// WEBPACK FOOTER //
// static/js/11.05575a11f87170cea62c.js